
export default {
    openSectionScrollDone: false
}


// WEBPACK FOOTER //
// ./public/scroll/initialState.js